<template>
 <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="MandatureForm" @submit="AddMandature" :validation-schema="MandatureSchema">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                Libellé Mandature<span class="text-danger">*</span>
                </label>
                <Field name="libelle" type="text" 
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrez un libellé"/>
              <ErrorMessage name="libelle" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Début  <span class="text-danger">*</span>
                </label>
                <Field name="dateDebut" type="date" 
                  class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateDebut" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Date Fin  <span class="text-danger">*</span>
                </label>
                <Field name="dateFin" type="date" 
                  class="form-control shadow-none fs-md-15 text-black"/>
                <ErrorMessage name="dateFin" class="text-danger"/>
              </div>
            </div>
            <div class="col-md-12">
              <div class="d-flex align-items-center ">
                <button
                  class="default-btn me-20 transition border-0 fw-medium text-white pt-10 
                  pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                  type="submit"
                >
                    Ajouter
                </button>
                <router-link to="/liste-mandature" 
                    class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
              </div>
        </div>
      </div>
    </Form>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { error, success } from "../../utils/utils";
import { useRoute, useRouter } from "vue-router";
import ApiService from "../../services/ApiService";
import { AlaUne } from "../../models/AlaUne";
import * as Yup from "yup";
import axios from "axios";
import { Mandature } from "@/models/postemembremandature";
import Swal from "sweetalert2";

export default defineComponent({
  name: "AddMandature",
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  
  setup: () => {
    const MandatureSchema = Yup.object().shape({
      libelle: Yup.string().required("Le libellé est obligatoire"),
      dateDebut: Yup.string().required("Le date de Début est obligatoire"),
      dateFin: Yup.mixed().required("La date de Fin est obligatoire"),
    });

    const MandatureForm = ref<Mandature | null>(null);
    const router = useRouter();


    onMounted(()=> {
      //
    })
    
    const AddMandature = async (values, { resetForm }) => {
     try {
        const response= await ApiService.post("/mandature", values);
        Swal.fire({
            title: "Mandature crée avec succès",
            icon: "success",
            draggable: true,
            confirmButtonText: "OK",
            timer: 1500
        }).then(() => {
             resetForm();
             router.push("/liste-mandature")
        });
          console.log("Mandature ajouté avec succès:", response.data); 
     }catch (error) {
        console.error("Erreur lors de l’envoi :", error);
        Swal.fire({
          title: "Erreur lors de l'ajout d'une mandature",
          icon: "error",
          draggable: true,
        });
      }
    };

    return { 
    AddMandature,
    MandatureSchema,
    MandatureForm
      
    };
  },
});
</script>
